"use client";

import * as React from "react";
import { FileText, GraduationCap, PenTool, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: "visa-assistance",
  title: "Visa Assistance",
  description: "Navigate complex global immigration requirements with our expert legal guidance to ensure a seamless transition to your new academic campus.",
  icon: FileText,
  href: "/ServicesPage"
}, {
  id: "admissions-guidance",
  title: "Admissions Guidance",
  description: "Strategic counseling to help you identify and secure placement in world-class institutions that align perfectly with your professional goals.",
  icon: GraduationCap,
  href: "/ServicesPage"
}, {
  id: "scholarship-strategy",
  title: "Scholarship Strategy",
  description: "Maximize your funding opportunities through curated research and high-impact application strategies for prestigious international financial aid.",
  icon: PenTool,
  href: "/ServicesPage"
}];
export default function ElevateYourApplication() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="201806" id="strategic-consulting-services" className="bg-background py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-secondary/5 blur-3xl rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`text-center max-w-2xl mx-auto mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-4 tracking-tight">
            Strategic Consulting Services
          </h2>
          <p className="text-muted-foreground font-default text-lg md:text-xl">
            Comprehensive support tailored to your academic journey, ensuring your ambition meets achievement at every step of the process.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Link key={service.id} to={service.href} data-index={i} className="block group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded">
                <Card className="h-full bg-card border-border border rounded transition-all duration-300 ease-in-out group-hover:scale-[1.02] group-hover:shadow-xl group-hover:border-secondary/30 relative overflow-hidden flex flex-col">
                  <CardHeader className="pb-4">
                    <div className="w-14 h-14 rounded bg-secondary/10 flex items-center justify-center mb-4 transition-colors group-hover:bg-secondary/20">
                      <Icon className="size-7 text-secondary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-xl font-bold text-foreground transition-colors group-hover:text-secondary">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <CardDescription className="text-muted-foreground font-default text-base leading-relaxed line-clamp-3">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="pt-4 pb-6 mt-auto">
                    <div className="flex items-center text-sm font-medium text-secondary">
                      <span className="relative overflow-hidden">
                        <span className="inline-block transition-transform duration-300 group-hover:-translate-y-full">
                          Learn More
                        </span>
                        <span className="absolute left-0 top-0 inline-block translate-y-full transition-transform duration-300 group-hover:translate-y-0">
                          Learn More
                        </span>
                      </span>
                      <ArrowRight className="size-4 ml-2 opacity-0 -translate-x-4 transition-all duration-300 ease-out group-hover:opacity-100 group-hover:translate-x-0" />
                    </div>
                  </CardFooter>
                </Card>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}